// ── Bit primitive (Phase 2A) ──
// The orange square that IS SustainBit's "i". Two Phase-2 instances:
//   GlassBitEcho — static at wordmark logo position, always rendered (#glass-canvas, z-30)
//   FieldBit     — descends across Hero→About per D17/D22 (#field-canvas, z-0)

// SB copper #FF824C — matches design system --copper: oklch(0.739 0.167 42.8).
// Hex chosen over computed-style read for canvas portability across iOS Safari.
const BIT_R = 0xff;
const BIT_G = 0x82;
const BIT_B = 0x4c;

export function drawBit(
  ctx: CanvasRenderingContext2D,
  x: number,
  y: number,
  size: number,
  alpha: number = 1,
): void {
  if (alpha < 0.01) return;
  ctx.fillStyle = `rgba(${BIT_R}, ${BIT_G}, ${BIT_B}, ${alpha})`;
  ctx.fillRect(x - size / 2, y - size / 2, size, size);
}
